import React, { Component } from 'react';
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { Form, Row, Col, Container } from 'react-bootstrap'
import TextField from "../common/form/TextField";
import PrimaryButton from '../common/form/PrimaryButton';
import LoginTop from "../top/LoginTop";
import { login } from "../../redux/actions/loginActions";
import LoginPageLinks from './LoginPageLinks';
import LoginPageSlides from './LoginPageSlides';
import LoginPageLatestNews from './LoginPageLatestNews';
import translations from "../../config/translation/login_translations.json"

import Footer from '../bottom/Footer'
import SkipLink from '../common/function/SkipLink';
import LoginPageSlidesSmall from './LoginPageSlidesSmall';

const mapStateToProps = state => {
	return {
		loginRegistration: state.countyConfigLoginRegistrationReducer,
		languages: state.countyConfigLanguagesReducer,
		language: state.languageReducer ? state.languageReducer : 'ENGLISH'
	};
}

const matchDispatchToProps = (dispatch) => {
	return {
		login: (credential, history, callback) => dispatch(login(credential, history, callback))
	}
}

class LoginBig extends Component {
	state = {
		username: "",
		password: "",
		error: "",
		loading: false
	}

	handleChange = (event) => {
		this.setState({
			error: "",
			[event.target.id]: event.target.value
		})
	}

	handleCallback = (status) => {
		this.setState({
			error: "",
			loading: false
		})
		if (status.error) {
			this.setState({
				error: status.message,
			})
		}
	}

	handleSubmit = (event) => {
		event.preventDefault();
		this.setState({
			loading: true
		})
		let { error, loading, ...request } = this.state; // remove UI only fields before submitting
		request.language = this.props.language;
		this.props.login(request, this.props.history, this.handleCallback);
	}

	render() {

		let mainContentRef = React.createRef();

		return (
			<>
				<SkipLink href={'#username'} description='Skip to Login Form' contentRef={mainContentRef} />
			<LoginTop pathname={this.props.location.pathname} />	
				<main style={{height: 750,  backgroundColor: '#114E6B'}}>
					<Container fluid="true" className='h-100'>
						<Row className='align-items-center' style={{ height: '85%', marginLeft: 10, marginRight: 10, paddingLeft: 13 }}  >
							<Col lg={8} md={6} sm={6} >
								{this.props.device === 'tablet' &&
								<LoginPageSlidesSmall/>
								}
									{this.props.device === 'desktop' &&
								<LoginPageSlides />
									}
							</Col>
							<Col lg={4} md={6} sm={6} >
								<Row>
									<LoginPageLatestNews key={this.props.language + "LOGINPAGELATESTNEWS"} language={this.props.language} />
								</Row>
								<Row><Col lg={12}>&nbsp;</Col></Row>
								<Row>
									<Form id="loginForm" onSubmit={this.handleSubmit} style={{ background: 'white', color: 'black',  borderRadius: 30, marginLeft: 10, marginRight: 0, paddingTop: 30, paddingBottom: 30, paddingLeft: 20, paddingRight: 20 }} >
										<Row>
											<Col lg={12}>
												<Form.Group controlId={'username'}>
													<TextField skipLinkRef={mainContentRef} formGroup={{ label: translations[this.props.language].username, labelFor: 'username', primaryCriteria: true, fieldType: 'text', required: true, style: { width: '100%' } }} onChange={this.handleChange} />
												</Form.Group>
											</Col>
										</Row>
										<Row>
											<Col lg={12}>
												<Form.Group controlId={'password'}>
													<TextField formGroup={{ label: translations[this.props.language].password, labelFor: 'password', primaryCriteria: true, fieldType: 'password', required: true }} onChange={this.handleChange} />
												</Form.Group>
											</Col>
										</Row>


										<Row>
											&nbsp;
										</Row>

										<Row className='align-items-center'>
											<Col lg={3} className='text-center' >
												<PrimaryButton buttonLabel={translations[this.props.language].log_in} />
											</Col>
											{

												this.props.loginRegistration.forgotPasswordLink === true &&
												<Col lg={3} className='text-center' >
													<span><NavLink to='/forgotUsername' style={{ color: 'rgb(17, 78, 107)' }}>{translations[this.props.language].forgot_username}?</NavLink></span>
												</Col>
											}
											{
												this.props.loginRegistration.forgotPasswordLink === true &&
												<Col lg={3} className='text-center' >
													<span><NavLink to='/forgotPassword' style={{ color: 'rgb(17, 78, 107)' }}>{translations[this.props.language].forgot_password}?&nbsp;&nbsp;</NavLink></span>
												</Col>
											}
											{
												this.props.loginRegistration.selfRegistration === true &&
												<Col lg={3} className='text-center' >
													<span><NavLink to='/register' style={{ color: 'rgb(17, 78, 107)' }}><strong>{translations[this.props.language].new_user}</strong></NavLink></span>
												</Col>
											}
										</Row>
										{
											this.state.error &&
											<Row className='align-items-center'>
												<Col lg={1} />
												<Col lg={10} className='text-center' style={{ fontWeight: 'bold', paddingTop: 10, paddingBottom: 10, marginTop: 10, background: 'lightgray', border: '3px solid red', color: 'red' }} >
													{this.state.error}
												</Col>
												<Col lg={1} />
											</Row>
										}
										{
											this.state.loading &&
											<Row className='align-items-center'>
												<Col lg={1} />
												<Col lg={10} className='text-center' style={{ fontWeight: 'bold', paddingTop: 10, paddingBottom: 10, marginTop: 10, background: 'lightgray', border: '3px solid #145A7B', color: '#145A7B' }} >
													Logging in...
												</Col>
												<Col lg={1} />
											</Row>
										}
									</Form>
								</Row>
							</Col>

						</Row>
						<LoginPageLinks key={this.props.language + "LOGINPAGELINKS"} language={this.props.language} />
					</Container>
				</main>
				<Footer />
			</>

		)
	}
}

export default connect(mapStateToProps, matchDispatchToProps)(LoginBig);